import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTextEdit"><Path d="M18.6121 3.18945L7 14.8015V20.0001H12.1986L23.8107 8.38804L18.6121 3.18945Z" fill="currentColor"/><Path d="M1 5.00011V6.50011H9.25C9.66421 6.50011 10 6.16433 10 5.75011C10 5.3359 9.66421 5.00011 9.25 5.00011H1Z" fill="currentColor"/><Path d="M1 9.00011V10.5001H6.25C6.66421 10.5001 7 10.1643 7 9.75011C7 9.3359 6.66421 9.00011 6.25 9.00011H1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextEdit;
